document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGaleria();
  initVariantes();
  initFlotantes();
});

function initFlotantes() {
  var botones = document.querySelectorAll('.mt-flotante-cta');
  if (!botones.length) return;
  var umbral = 480;
  var ticking = false;

  function actualizar() {
    var visible = window.scrollY > umbral;
    botones.forEach(function (btn) {
      btn.classList.toggle('mt-flotante-visible', visible);
    });
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }, { passive: true });

  actualizar();
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-delay', Math.min(i % 4, 3) * 0.1 + 's');
    observer.observe(el);
  });
}

function initGaleria() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.removeAttribute('srcset'); // al elegir otra foto se usa su versión grande
        principal.src = src;
        miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
      });
    });

    // Deslizar el dedo sobre la foto grande (izquierda / derecha) pasa a la foto siguiente o anterior
    var zona = galeria.querySelector('.mt-galeria__principal');
    if (!zona) return;
    zona.style.touchAction = 'pan-y';
    var x0 = null, y0 = null;
    zona.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    zona.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      // Solo las miniaturas visibles (las de otro color pueden estar ocultas)
      var visibles = Array.prototype.filter.call(galeria.querySelectorAll('[data-mt-miniatura], [data-mt-mini-video]'), function (m) { return m.offsetParent !== null; });
      if (visibles.length < 2) return;
      var actual = visibles.findIndex(function (m) { return m.classList.contains('mt-activa'); });
      if (actual < 0) actual = 0;
      var sig = (actual + (dx < 0 ? 1 : -1) + visibles.length) % visibles.length;
      principal.style.transition = 'opacity .18s ease';
      principal.style.opacity = '0.35';
      visibles[sig].click();
      setTimeout(function () { principal.style.opacity = '1'; }, 120);
      // La miniatura elegida se ve en la tira (si hay muchas y se desplaza)
      if (visibles[sig].scrollIntoView) visibles[sig].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }, { passive: true });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var inputId = form.querySelector('input[name="id"]');
    // El precio vive fuera del formulario, en el bloque de compra que lo contiene
    var raiz = form.closest('.mt-compra') || form;
    var precioActual = raiz.querySelector('[data-mt-precio-actual]');
    var precioAnterior = raiz.querySelector('[data-mt-precio-anterior]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');
    var disponibilidad = form.querySelector('[data-mt-disponibilidad]');
    var selectores = form.querySelectorAll('[data-mt-opcion]');

    function variantePorOpciones() {
      var seleccion = [];
      selectores.forEach(function (grupo) {
        var activo = grupo.querySelector('.mt-activa');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
    }

    function formatoDinero(centavos) {
      // Mismo formato que Shopify en la tienda: $20.99
      return (centavos / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
      });
    }

    function actualizar() {
      var variante = variantePorOpciones();
      if (!variante) return;
      inputId.value = variante.id;
      // Si algún color tiene su propia foto, al elegirlo se muestra esa foto (y al volver, la portada)
      var hayFotosPorColor = variantes.some(function (v) { return v.imagen; });
      var galeria = document.querySelector('[data-mt-galeria]');
      var primeraVez = !form.dataset.mtFotoIniciada;
      form.dataset.mtFotoIniciada = '1';
      // Al abrir la página se mantiene la portada; la foto cambia solo cuando el cliente elige un color
      if (hayFotosPorColor && galeria && !primeraVez) {
        var principal = galeria.querySelector('[data-mt-imagen-principal]');
        var minis = galeria.querySelectorAll('[data-mt-miniatura]');
        var destino = variante.imagen || (minis[0] && minis[0].getAttribute('data-full'));
        if (principal && destino) {
          principal.removeAttribute('srcset');
          principal.src = destino;
          var base = function (u) { return (u || '').split('?')[0].replace(/_\d+x\d*(?=\.)/, ''); };
          minis.forEach(function (m) { m.classList.toggle('mt-activa', base(m.getAttribute('data-full')) === base(destino)); });
        }
      }
      if (precioActual) precioActual.textContent = formatoDinero(variante.price);
      if (precioAnterior) {
        // 04/11/2026: la palabra "Antes" va en una caja aparte; se oculta junto con el precio tachado
        var cajaAntes = precioAnterior.closest('.mt-compra__antes');
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = formatoDinero(variante.compare_at_price);
          precioAnterior.hidden = false;
          if (cajaAntes) cajaAntes.style.display = '';
        } else {
          precioAnterior.hidden = true;
          if (cajaAntes) cajaAntes.style.display = 'none';
        }
      }
      if (botonComprar) botonComprar.disabled = !variante.available;
      if (disponibilidad) {
        if (variante.available) {
          disponibilidad.textContent = disponibilidad.getAttribute('data-texto-disponible') || 'En stock';
          disponibilidad.classList.remove('mt-agotado');
          disponibilidad.classList.add('mt-disponible');
        } else {
          disponibilidad.textContent = disponibilidad.getAttribute('data-texto-agotado') || 'Agotado';
          disponibilidad.classList.remove('mt-disponible');
          disponibilidad.classList.add('mt-agotado');
        }
      }
    }

    selectores.forEach(function (grupo) {
      grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
          btn.classList.add('mt-activa');
          actualizar();
        });
      });
    });

    actualizar();
  });
}
